import { render, staticRenderFns } from "./ModalFornecedor.vue?vue&type=template&id=515e3d01&scoped=true"
import script from "./ModalFornecedor.vue?vue&type=script&lang=js"
export * from "./ModalFornecedor.vue?vue&type=script&lang=js"
import style0 from "./ModalFornecedor.vue?vue&type=style&index=0&id=515e3d01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515e3d01",
  null
  
)

export default component.exports